import { render, staticRenderFns } from "./rgb.vue?vue&type=template&id=dea9c39c&"
import script from "./rgb.js?vue&type=script&lang=js&"
export * from "./rgb.js?vue&type=script&lang=js&"
import style0 from "./rgb.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VSwitch})
